<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-18T20:46:35+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-16T14:00:29+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>
        <div v-if="show_menu && menu_type != null">
            <div class="card ccb_green" >
                <div class="d-flex flex-wrap p-1" style="border-radius: 0.2rem; border: 1px solid #27926b;"><!-- background-color: #34c38f; -->
                    <div class="me-2">
                        <div class="text-light">
                            <img
                            class="rounded-circle header-profile-user"
                            src="@/assets/user.png"
                            alt="Header Avatar"
                            />
                            <span style="font-size: 0.9rem;" class="d-none d-xl-inline-block ms-1">
                                <strong>
                                    {{clientName}}
                                </strong>
                            </span>
                        </div>
                    </div>
                    <div class="ms-auto">
                        <b-button @click="toggleMenu" size="sm" class="float-end ms-1 font-size-12" style="height: 100%;" variant="light">
                            <i class="fas fa-bars"></i><!-- fas fa-ellipsis-h -->
                        </b-button>
                    </div>
                </div>


                <b-collapse v-model="router_collapse" id="routerMenu" class="">
                    <div class="p-1 mt-1" id="routerLinks" style="margin-left: 1.8rem; margin-right: 1.8rem;">
                        <!-- //* CCB ADMIN MENU START -->
                        <div v-if="clientType === 'ccb_admin'">
                            <b-link active-class="ccb_button_active" style="width: 100%;" to="/admin/applicants">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">Applicants</div>
                                </div>
                            </b-link>

                            <b-link active-class="ccb_button_active" style="width: 100%;" to="/admin/administration">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">Administration</div>
                                </div>
                            </b-link>

                            <b-link active-class="ccb_button_active" style="width: 100%;" to="/documents">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">SOP's</div>
                                </div>
                            </b-link>
                        </div>


                        <!-- //* CLIENT ADMIN MENU START -->
                        <div v-if="clientType === 'client_admin'">
                            <b-link active-class="ccb_button_active" style="width: 100%;" to="/clientadmin/timeline">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">Application</div>
                                </div>
                            </b-link>
                            <b-link active-class="ccb_button_active" style="width: 100%;" to="/clientadmin/administration">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">Administration</div>
                                </div>
                            </b-link>
                            <b-link active-class="ccb_button_active" style="width: 100%;" to="/clientadmin/facility">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">Facility Management</div>
                                </div>
                            </b-link>
                            <b-link v-if="requiresPreApplication == false" active-class="ccb_button_active" style="width: 100%;" to="/documents">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">SOP's</div>
                                </div>
                            </b-link>
                        </div>


                        <!-- //* CLIENT MENU START -->
                        <div v-if="clientType === 'client'">
                            <b-link active-class="ccb_button_active" style="width: 100%;" to="/client/timeline">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">Application</div>
                                </div>
                            </b-link>
                            <b-link active-class="ccb_button_active" style="width: 100%;" to="/client/administration">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">Administration</div>
                                </div>
                            </b-link>
                            <b-link v-if="requiresPreApplication == false" active-class="ccb_button_active" style="width: 100%;" to="/documents">
                                <div class="ccb_button mb-3">
                                    <div class="ccb_button_text">SOP's</div>
                                </div>
                            </b-link>
                        </div>

                        <div class="d-flex" style="justify-content: space-between;">
                            <div class="d-flex" style="flex-direction: column;">
                                <div @click="handleLogout" class="ccb_small_button d-flex" style="align-content: center; align-items: center">
                                    <i class="w-100 ccb_button_icon bx bx-exit"></i>
                                </div>
                                <p class="ccb_icon_text">Logout</p>
                            </div>
                            <!-- -->
                            <div class="d-flex" style="flex-direction: column;">
                                <div class="ccb_small_button d-flex" @click="$router.push('/profile')" style="align-content: center; align-items: center">
                                    <i class="w-100 ccb_button_icon bx bx-user"></i>
                                </div>
                                <p class="ccb_icon_text">Settings</p>
                            </div>
                        </div>
                    </div>
                </b-collapse>

                <b-collapse v-model="context_collapse" id="contextView" visible>
                    
                    <SopTree v-if="menu_type == 'documents'" />
                    <SopEdit v-if="menu_type == 'documents_edit'" />
                    <SopView v-if="false &&  menu_type == 'documents_view'" />

                    <ClientAdminAdministration v-if="menu_type == 'clientadmin_administration'" />

                    <DistributionMenu v-if="menu_type == 'client_admin_distribution'" />

                    <div v-if="menu_type === 'ccb_applicants'">
                        <div class="card card-body" style="height: 10rem;">
                            <b-button variant="outline-primary">Add Applicant</b-button>
                        </div>
                    </div>

                    <div v-if="menu_type === 'clientadmin_facility'" >
                        <div class="card-body">
                            <div class="card-title text-white">
                                Facility Management
                            </div>
                            <b-row class="pt-2">
                                <b-col cols="12">
                                    <div class="ccb_button mb-3">
                                        <div class="ccb_button_text" @click="setFacilityClientAdminView('suppliers')"  >
                                            <span :class="facility_view == 'suppliers' ? 'activeBtn' : ''">Suppliers</span>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col cols="12">
                                    <div class="ccb_button mb-3">
                                        <div class="ccb_button_text" @click="setFacilityClientAdminView('locations')"  >
                                            <span :class="facility_view == 'locations' ? 'activeBtn' : ''">Locations</span>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col cols="12">
                                    <div class="ccb_button mb-3">
                                        <div class="ccb_button_text" @click="setFacilityClientAdminView('audit')"  >
                                            <span :class="facility_view == 'audit' ? 'activeBtn' : ''">Audits</span>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>

                    <div v-if="menu_type === 'ccb_administration'">
                            <div class="card card-body" style="height: 10rem;">
                                <div class="card-title">
                                    Administration
                                </div>
                            </div>
                        </div>
                    <div v-if="clientType === 'client'">
                        <div v-if="menu_type === 'client_documents'">
                            <clientTreeMenu/>
                        </div>
                        <div v-else-if="menu_type === 'client_administration'">
                            <b-card title="User Profile"></b-card>
                        </div>
                    </div>
                </b-collapse>
            </div>
        </div>
        <div v-else>
            <!-- <i @click="navigateBack" ref="viewCloseButton" id="view-close-button" style="font-size: 3rem;" class="fas fa-times mb-4 pb-2 primary-text-colour"></i> -->
            <div v-if="menu_type === 'document_edit'">
                <EditMenu/>
            </div>
        </div>
    </div>
</template>

<script>
import { clientAdminState, clientAdminMethods, sopAdminMethods } from '@/state/helpers'
import { facilityAdminState, facilityAdminMethods } from '@/state/helpers'
import { layoutComputed, layoutMethods} from '@/state/helpers'
import EditMenu from './NavBar/sideMenus/edit-documents.vue'
import { authMethods } from '@/state/helpers'
import ccbTreeMenu from "./NavBar/sideMenus/ccb_admin/ccb-tree-menu.vue";
import clientAdminTreeMenu from "./NavBar/sideMenus/client_admin/ca-tree-menu.vue";
import clientTreeMenu from "./NavBar/sideMenus/client/c-tree-menu.vue";

import store from '@/state/store'

//import individual components to slot into the emitted menu type
import ClientAdminAdministration from '@/components/widgets/menu-components/clientadmin/administration.vue'

import SopTree from "./NavBar/sideMenus/sop/sopTree.vue";
import SopEdit from "./NavBar/sideMenus/sop/sopEdit.vue";
import SopView from "./NavBar/sideMenus/sop/sopView.vue";
import DistributionMenu from './NavBar/sideMenus/sop/distributionMenu.vue'

export default {
    components:{
        EditMenu,
        //eslint-disable-next-line
        ccbTreeMenu,
        //eslint-disable-next-line
        clientAdminTreeMenu,
        clientTreeMenu,
        //clientadmin
        //eslint-disable-next-line
        ClientAdminAdministration,
        SopTree,
        SopView,
        SopEdit,
        DistributionMenu,
    },
    watch:{
        $route (){
            this.updateMenuType({
                type: 'null',
                showMenu: true,
                showRoutes: false,
            })
        },

        menu_type(){

        }
    },
    data:() => ({
        router_collapse: false,
        context_collapse: true,

        /*show_router_menu: true,
        menu_type: null,*/
    }),
    computed:{
        ...layoutComputed,
        ...clientAdminState,
        ...facilityAdminState,
        hasCoreData(){
        if(this.core_data != null){
            return true;
        }
        else{
            return false;
        }
        },
        clientName(){
            return this.core_data != null ? this.core_data.full_name : '';
        },
        clientType(){
            let client = '';
            if(this.core_data != null){
                client = 'client';
                if(this.core_data.ccb_admin){
                    client = 'ccb_admin';
                }
                else if(this.core_data.client_admin){
                    client = 'client_admin';
                }
            }

            return client;
        },
        requiresPreApplication(){
            //* hide other available routes if user needs to complete pre inspection application
            if(this.core_data.pre_application){
                return true;
            }
            else{
                return false;
            }
        }
    },
    methods: {
        ...authMethods,
        ...layoutMethods,
        ...sopAdminMethods,
        ...clientAdminMethods,
        ...facilityAdminMethods,
        toggleMenu(){
            this.context_collapse = !this.context_collapse;
            this.router_collapse = !this.router_collapse;
        },
        /*updateMenuType(payload){
            this.menu_type = payload.type;
            this.show_router_menu = payload.showRoutes;
        },*/
        navigateBack(){
            this.clearSopStore();
            this.$emit('back');
        },
        handleLogout(){
            window.axios.get('api/auth/logout')
            .then(()=>{
                window.localStorage.removeItem('x_token');
                window.localStorage.removeItem('auth.currentUser');
                this.logOut().then(()=>{
                    this.$nextTick(()=>{
                        this.clearCoreData();
                        this.$router.push({name: 'login'});
                        this.$nextTick(()=>{
                            store.dispatch('ccbAdmin/clearAll');
                            store.dispatch('clientAdmin/clearAll');
                            store.dispatch('facilityAdmin/clearAll');
                            store.dispatch('layout/clearAll');
                            store.dispatch('licenseApp/clearAll');
                            store.dispatch('sopAdmin/clearAll');
                            store.dispatch('sopClient/clearAll');
                            store.dispatch('sopClientAdmin/clearAll');
                            store.dispatch('sop/clearAll');
                        })
                    })
                })
            })
        },


        //* client admin facility view
        setFacilityClientAdminView(type){
            this.setFacilityView(type);
        }
    },
    mounted(){

        //this.$eventHub.$on('displayMenu', this.updateMenuType);
    },
    beforeDestroy(){
        //this.$eventHub.$off('displayMenu');
    }
}
</script>


<style>
.ccb_green{
    background-image: linear-gradient( 96.5deg,  rgba(39,103,187,1) 10.4%, rgba(16,72,144,1) 87.7% );
}
.ccb_button{
    text-align: center;
    width: 100%;
    background: #FFFFFF;
    border-radius: 10px;
}
.ccb_button:hover{
    text-decoration: underline;
}
.ccb_button_active>.ccb_button{
    background: #ffffffbd;
    text-decoration: underline;
    color: rgba(16,72,144,1);
}
.ccb_button_active>.ccb_button>.ccb_button_text{
    color: rgba(16,72,144,1);
}
@media only screen and (max-width: 992px) {

    .ccb_button_text{
        font-size: 0.8rem !important;
    }
    .ccb_button_icon{
        font-size: 1.2rem !important;
    }
}
.ccb_button_text{
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;

    color: rgba(39,103,187,1)
}
.ccb_button_icon{
    font-style: normal;
    font-weight: normal;
    font-size: 2rem;
    color: rgba(39,103,187,1)
}

.ccb_small_button{
    text-align: center;
    background: #FFFFFF;
    border-radius: 10px;
    width: 3rem;
    height: 3rem;
    transition: all 0.1s linear;
}
.ccb_small_button:hover{
    cursor: pointer;
    background-color: rgba(37,249,245,1);
    transition: all 0.2s linear;
}
.ccb_icon_text{
    text-align: center;
    color: #FFFFFF;
}


.activeBtn{
  font-weight: bold;
  text-decoration: underline;
}

#routerLinks.btn{
  color:forestgreen;
}
.routerBtn{
  color: #000 !important;
  background-color: unset !important;
  border-color: #eff2f7 !important;
}
.routerBtn.router-link-active{
  color: #000 !important;
  background-color: #eff2f7 !important;
  border-color: #eff2f7 !important;
}
</style>
